<div class="web-sites-editor-container">
    <div class="header-container">
        <label>{{ title }}</label>
        <smart-icon name="close" (click)="onSlideSheetClose()" class="light"></smart-icon>
    </div>
    <div class="input-container">
        <div class="tam-form-field" tid="id">
            <label>ID</label>
            <input [(ngModel)]="webSites.ID" class="tam-input tam-textbox" type="text" value="webSites.ID"
                [readonly]="true" [class.disabled]="true">
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error':name.invalid}" tid="name">
            <label class="required">Name</label>
            <input [(ngModel)]="webSites.name" class="tam-input tam-textbox" type="text" value="webSites.name"
                [formControl]="name">
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error': URL.invalid}" tid="URL">
            <label class="required">URL</label>
            <input [(ngModel)]="webSites.URL" class="tam-input tam-textbox" type="text" value="webSites.URL"
                [formControl]="URL">
            <div class="tam-form-help" *ngIf="URL.invalid && URL.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field" tid="javascript">
            <label>Javascript</label>
            <textarea class="tam-textbox textarea" [(ngModel)]="webSites.javascript"
                value="webSites.javascript"></textarea>
        </div>
        <label>Configuration options</label>
        <div class="config-option" tid="autoRefresh">
            <div tid="enableAutoRefresh">
                <label>Enable auto refresh</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.autoRefreshChecked"></kendo-switch>
                </div>
            </div>
            <div tid="enableAutoRefreshCheckbox">
                <label>Enable auto refresh checkbox&nbsp;&nbsp;&nbsp;</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.autoRefreshEnabled"></kendo-switch>
                </div>
            </div>
        </div>
        <div class="config-option" tid="blockPopups">
            <div tid="enableBlockPopups">
                <label>Enable block popups</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.blockPopupChecked"></kendo-switch>
                </div>
            </div>
            <div tid="enableBlockPopupsCheckbox">
                <label>Enable block popups checkbox</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.blockPopupEnabled"></kendo-switch>
                </div>
            </div>
        </div>
        <div class="config-option" tid="focusChange">
            <div tid="enableFocusChange">
                <label>Enable focus change</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.focusChangeChecked"></kendo-switch>
                </div>
            </div>
            <div tid="enableFocusChangeCheckbox">
                <label>Enable focus change checkbox&nbsp;</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off"
                        [(ngModel)]="webSites.webSiteDialogAttributes.focusChangeEnabled"></kendo-switch>
                </div>
            </div>
        </div>
        <div class="tam-form-field" tid="symbolFormatList">
            <label>Supported symbol formats (comma separated)</label>
            <input [(ngModel)]="webSites.symbolFormatList" class="tam-input tam-textbox" type="text"
                value="webSites.symbolFormatList">
        </div>
        <div class="tam-form-field" tid="submitPDF">
            <label>Submit as PDF</label>
            <div>
                <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="webSites.submitPDF"></kendo-switch>
            </div>
        </div>
        <div class="tam-form-field" tid="PDF_URL">
            <label>PDF URL</label>
            <input [(ngModel)]="webSites.PDF_URL" class="tam-input tam-textbox" type="text" value="webSites.PDF_URL">
        </div>
        <div class="tam-form-field" tid="params">
            <label>Parameters</label>
            <input [(ngModel)]="webSites.params" class="tam-input tam-textbox" type="text" value="webSites.params">
        </div>
        <div class="tam-form-field" tid="tamaleAuthentication">
            <label>Tamale Authentication</label>
            <div>
                <kendo-switch onLabel="On" offLabel="Off" [(ngModel)]="webSites.tamaleAuthentication"></kendo-switch>
            </div>
        </div>
    </div>
    <div class="button-container" tid="buttons">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
            {{'general.submit' | stringLiterals}}
        </button>
        <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" class="button" (click)="onSlideSheetClose()">
            {{'general.cancel' | stringLiterals}}
        </button>
    </div>
</div>